/*
 * Store List（取扱店）の地域切替。
 * PC（≥1025px）＝右上の地域タブで1地域だけ表示（他は hidden）。details は常時 open。
 * SP（≤1024px）＝タブ非表示・地域は縦積みのアコーディオン（ネイティブ <details>）。初期は先頭だけ開く。
 * markup は sections/store-directory.liquid、見た目は assets/custom.css の `.stockists*`。
 */
if (!customElements.get('stockist-directory')) {
  customElements.define(
    'stockist-directory',
    class StockistDirectory extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('.stockists__tab'));
        this.regions = Array.from(this.querySelectorAll('.stockists__region'));
        if (this.regions.length === 0) return;

        this.mql = window.matchMedia('(max-width: 1024px)');
        const selected = this.tabs.find((t) => t.getAttribute('aria-selected') === 'true');
        this.activeRegion = (selected || this.tabs[0] || this.regions[0]).dataset.region;

        this.onTabClick = (event) => this.setActive(event.currentTarget.dataset.region);
        this.onTabKey = (event) => this.handleTabKey(event);
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', this.onTabClick);
          tab.addEventListener('keydown', this.onTabKey);
        });

        // PC では summary クリックで閉じない（CSS pointer-events:none との二重防御）
        this.onSummaryClick = (event) => {
          if (!this.mql.matches) event.preventDefault();
        };
        this.regions.forEach((region) => {
          const head = region.querySelector('.stockists__region-head');
          if (head) head.addEventListener('click', this.onSummaryClick);
        });

        this.onModeChange = () => this.applyMode();
        this.mql.addEventListener('change', this.onModeChange);
        this.applyMode();
      }

      disconnectedCallback() {
        this.mql?.removeEventListener('change', this.onModeChange);
      }

      applyMode() {
        if (this.mql.matches) {
          // SP：全地域を表示し、先頭だけ開く（残りは閉じる＝アコーディオン）
          this.regions.forEach((region, index) => {
            region.hidden = false;
            region.open = index === 0;
          });
        } else {
          // PC：全地域を open 固定。タブがあればアクティブ地域だけ表示、無ければ全地域表示
          this.regions.forEach((region) => {
            region.open = true;
          });
          if (this.tabs.length > 0) {
            this.setActive(this.activeRegion);
          } else {
            // 絞り込み UI（タブ）が無い＝全地域をそのまま見せる（隠さない）
            this.regions.forEach((region) => {
              region.hidden = false;
            });
          }
        }
      }

      setActive(region) {
        this.activeRegion = region;
        this.tabs.forEach((tab) => {
          const on = tab.dataset.region === region;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
        });
        if (!this.mql.matches && this.tabs.length > 0) {
          this.regions.forEach((r) => {
            r.hidden = r.dataset.region !== region;
          });
        }
      }

      handleTabKey(event) {
        const index = this.tabs.indexOf(event.currentTarget);
        if (index < 0) return;
        const last = this.tabs.length - 1;
        let next = null;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = this.tabs[index === last ? 0 : index + 1];
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = this.tabs[index === 0 ? last : index - 1];
        else if (event.key === 'Home') next = this.tabs[0];
        else if (event.key === 'End') next = this.tabs[last];
        if (next) {
          event.preventDefault();
          next.focus();
          this.setActive(next.dataset.region);
        }
      }
    }
  );
}
